import styled from "styled-components/macro";
import { useQuery } from "@tanstack/react-query";
import MessageTemplatePreview from "./MessageTemplatePreview";
import { HelpText } from "../Input";
import Title from "../Title";
import Stack from "../Stack";
import { fetchCampaign } from "../../api/campaigns";

export default function CampaignPreview({
  campaignId,
}: {
  campaignId: string;
}) {
  // TODO: Remove non-null assertion after migration to useSuspenseQuery
  const campaign = useQuery({
    queryKey: ["campaigns", campaignId],
    queryFn: () => fetchCampaign(campaignId),
  }).data!;

  return (
    <Container>
      <Stack>
        <Center>
          <Title>{campaign.name}</Title>
          {Boolean((campaign.description || "").trim()) && (
            <HelpText>{campaign.description}</HelpText>
          )}
        </Center>

        <>
          {campaign.messageTemplates.map((messageTemplate) => (
            <MessageTemplatePreview
              messageTemplate={messageTemplate}
              key={messageTemplate.id}
            />
          ))}
        </>
      </Stack>
    </Container>
  );
}

const Container = styled.div``;
const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
